import MDTypography from '@components/MDTypography';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Grid from '@mui/material/Grid';
import React from 'react';

interface Props {
  label: string;
  icon: IconProp;
}

const MenuItem: React.FC<Props> = ({ label, icon }) => (
  <Grid container alignItems={'center'}>
    <FontAwesomeIcon icon={icon} />
    <MDTypography ml={2} sx={{ fontSize: '18px' }}>
      {label}
    </MDTypography>
  </Grid>
);

export default MenuItem;
